var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-config-provider"},[(_vm.hasReadyVideoConfig)?_c('GenericVideoJSPlayer',{attrs:{"globalReference":_vm.globalReference,"options":_vm.videoOptionsWithMuxConfig,"chaptersVtt":_vm.videoConfig.chapters_vtt_url,"textTracks":_vm.videoConfig.text_tracks}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }